import { InjectionToken } from '@angular/core';

export const RESPONSE = new InjectionToken<Response>('RESPONSE');
export const SSR_PATH = new InjectionToken<string>('SSR_PATH');
export const SSR_ACCEPT_LANGUAGE = new InjectionToken<string>('SSR_ACCEPT_LANGUAGE');


